import { Injectable } from "@angular/core";
import { Meta, Title } from "@angular/platform-browser";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { TranslocoService } from "@ngneat/transloco";
import { filter, map, mergeMap } from "rxjs/operators";
import { environment } from "@env";

@Injectable({
  providedIn: "root",
})
export class TitleService {
  constructor(
    private _title: Title,
    private _router: Router,
    private _meta: Meta,
    private _route: ActivatedRoute,
    private _translocoService: TranslocoService,
  ) {
    this._router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this._route),
        map((route) => {
          while (route.firstChild) route = route.firstChild;
          return route;
        }),
        mergeMap((route) => route.data),
      )
      .subscribe((data) => {
        const titleKey: string = data["title"] || "title.default";
        const descriptionKey: string | undefined = data["description"];

        const translatedTitle: string = this._translocoService.translate(titleKey);
        const translatedDescription: string = descriptionKey
          ? this._translocoService.translate(descriptionKey)
          : "";

        const envPrefix: string = this._getEnvironmentPrefix();
        const finalTitle: string = `${envPrefix}${translatedTitle}`;

        this._title.setTitle(finalTitle);
        this.setDescription(translatedDescription);
      });
  }

  public setTitle(customTitle: string): void {
    const envPrefix: string = this._getEnvironmentPrefix();
    const finalTitle: string = `${envPrefix}${customTitle}`;
    this._title.setTitle(finalTitle);
  }

  public setDescription(customDescription: string): void {
    this._meta.updateTag({ name: "description", content: customDescription });
  }

  private _getEnvironmentPrefix(): string {
    if (!environment.production) {
      if (environment.title === "local") {
        return "Local - ";
      } else if (environment.title === "dev") {
        return "Dev - ";
      }
    }
    return "";
  }
}
